import React from 'react';

export function AlogEvents() {
  return <div>alog events</div>;
}
